import React from 'react';
import { FormattedMessage } from 'react-intl';

const Title = ({ isOpen, gender, product, measurementSystem, region }) => {
  return (
    <div className="interactive-size-guide__title">
      {isOpen ? (
        <>&nbsp;</>
      ) : (
        <span>
          {gender.value} - <strong>{product.value}</strong> -{' '}
          <strong className="interactive-size-guide__title-red">
            <FormattedMessage id={region.name} />
          </strong>{' '}
          <strong className="interactive-size-guide__title-red">
            &#40;
            <FormattedMessage id={measurementSystem.abbrev} />
            &#41;
          </strong>
        </span>
      )}
    </div>
  );
};

export default Title;
